import { Dialog, Button, DialogActions, DialogContent, DialogTitle, Grid, TextField, Skeleton, useMediaQuery, createTheme } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/styles'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'

import Recaptcha from 'react-recaptcha'
import { config, siteColors } from '../../../common/config'
import { siteMessages } from '../../../common/tools'
import AlertMessage from '../../common/Alert/AlertMessage'

const theme = createTheme()
const useStyles = makeStyles(() => ({
    mainTitle: {
        paddingBottom: '1rem',
        fontWeight: '400',
        textTransform: 'uppercase',
        color: siteColors.main.logo,
        display: 'inline-block'
    },
    mainCloseBtn: {
        float: 'right',
        fontSize: '2rem!important',
        '&:hover': {
            color: siteColors.main.logo,
            cursor: 'pointer',
        }
    }
}))

const CheckOrder = (props) => {
    const classes = useStyles()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [reCaptchaSuccess, setReCaptchaSuccess] = useState(false)
    const [loadRecaptcha, setLoadRecaptcha] = useState(false)
    const [openAlert, setOpenAlert] = useState(null)
    const { control, handleSubmit, reset, formState: { errors } } = useForm()
    const handleClose = () => {
        props.handleClose()
        reset()
        setReCaptchaSuccess(false)
    }

    const onSubmit = (data) => {
        let formData = new FormData()
        formData.append('order_id', data.order_id.replaceAll(' ', ''))
        formData.append('tiket', data.orderTicket)
        handleClose()
        props.submit(formData)
    }

    const { t } = useTranslation()


    var callback = function () {
        console.log('reCaptcha success');
        setLoadRecaptcha(true)
    };

    // specifying verify callback function
    var verifyCallback = function (response) {
        if (response) {
            setReCaptchaSuccess(true)
        }
    };
    useEffect(() => {
        if (props.alertMessage.length < 1) {
            setOpenAlert(null)
        }
        if (!props.hasApplicant && props.alertMessage.length > 0) {
            setOpenAlert(false)
        }
        if (props.hasApplicant && props.alertMessage.length > 0) {
            setOpenAlert(true)
        }

    }, [props.alertMessage])
    return (
        <div>
            <AlertMessage open={openAlert} message={props.alertMessage} handleClose={() => { setOpenAlert(null) }} />
            <Dialog
                fullWidth
                fullScreen={fullScreen}
                open={props.open}
                onClose={handleClose}
                maxWidth={'md'}

            >
                <DialogTitle sx={{ borderBottom: '1px solid #ccc' }}>
                    <div className={classes.mainTitle + ' h3'} >{t('check-order')}</div>
                    <span onClick={handleClose}>
                        <Close className={classes.mainCloseBtn} />
                    </span>
                </DialogTitle>
                <DialogContent sx={{ marginTop: '2.5rem' }}>

                    <Grid container justifyContent={'center'}>
                        <Grid item lg={6} md={6} sm={8} xs={10}>
                            <br />
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Controller
                                    name='order_id'
                                    rules={{
                                        required: { value: true, message: t('required') },
                                        pattern: { value: /^[0-9- ]{12}[0-9]{1}$/g, message: siteMessages.validation.inputCorrectly('номер заявки') }
                                    }}
                                    control={control}
                                    defaultValue=''
                                    render={({ field }) => (
                                        <NumberFormat {...field} fullWidth variant='outlined' error={errors.order_id} helperText={errors.order_id?.message} customInput={TextField} format='#### - ######' label={t('yuzlenmanin belgisi')} />
                                    )}

                                />
                                <br />
                                <br />
                                <Controller
                                    name='orderTicket'
                                    rules={{
                                        required: { value: true, message: t('required') },
                                        pattern: { value: /^[0-9]{8}$/g, message: siteMessages.validation.inputCorrectly('тикет') }
                                    }}
                                    control={control}
                                    defaultValue=''
                                    render={({ field }) => (
                                        <NumberFormat {...field} fullWidth variant='outlined' error={errors.orderTicket} helperText={errors.orderTicket?.message} customInput={TextField} format='########' label={t('tiket belgisi')} />
                                    )}

                                />
                                {!loadRecaptcha && <Skeleton variant="rectangular" width={250} height={80} sx={{ marginTop: '1.5rem' }} />}
                                <div className='t-center' style={!loadRecaptcha ? { display: 'none' } : { display: 'block' }}>
                                    <br />
                                    <Recaptcha
                                        sitekey={config.reCaptchaKey}
                                        render="explicit"
                                        verifyCallback={verifyCallback}
                                        onloadCallback={callback}


                                    />
                                </div>
                                <br />

                                <div className='t-center' >
                                    {/* <Button  type='submit' variant='text' size='large' style={{cursor:'pointer'}}><div className='h3'>Войти</div></Button> */}

                                    {reCaptchaSuccess ? <Button type='submit' variant='text' size='large' style={{ cursor: 'pointer' }}><div className='h3'>{t('girmek')}</div></Button> : <Button disabled type='button' variant='text' size='large' style={{ cursor: 'pointer' }}><div className='h3'>{t('girmek')}</div></Button>}
                                </div>


                            </form>


                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <div style={{ padding: '1rem' }}>
                        <Button onClick={handleClose} color='error' variant='contained' sx={{ cursor: 'pointer' }}>{t('yapmak')}</Button>

                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )
}


export default CheckOrder